import { WarningCircleIcon } from '@phosphor-icons/react';
import type { HarnessActionFailedResult } from '@erp/shared-types';
import { Card } from '@/components/ui/card';

/** An action the assistant could not perform; the message is the page's own. */
export function NamiFailedCard({
  result,
}: {
  result: HarnessActionFailedResult;
}) {
  return (
    <Card className="flex items-start gap-2 border-destructive/30 p-3">
      <WarningCircleIcon className="mt-0.5 size-4 shrink-0 text-destructive" />
      <div className="text-sm text-card-foreground">{result.message}</div>
    </Card>
  );
}
